// extracted by mini-css-extract-plugin
module.exports = {"pizzaProgress":"PizzaProgress_pizzaProgress__1hl8r","bar":"PizzaProgress_bar__2xi3f","fadeIn":"PizzaProgress_fadeIn__18zKh","fadeOut":"PizzaProgress_fadeOut__1EQ4j"};